module.exports = __webpack_public_path__ + "img/oct_21.c8f8324c.png";